module.exports = __webpack_public_path__ + "img/tool.4b74c6a4.jpg";